import {UIGameAnimationBase} from './UIGameAnimationBase'

export abstract class UIGameTimedAnimation extends UIGameAnimationBase {
    protected duration: number
    protected totalElapsedMS = 0

    constructor(duration: number) {
        super()
        this.duration = duration
    }

    onGameTick(deltaTime: number, elapsedMS: number) {
        this.totalElapsedMS += elapsedMS
        if(this.totalElapsedMS >= this.duration) {
            this.stop()
            return
        }

        this.updateAnimation(deltaTime, elapsedMS)
    }

    abstract updateAnimation(deltaTime: number, elapsedMS: number): void
}
